<template>
  <div>
    <div>
      <b-row class="justify-content-center">
        <b-col md="8" class="text-center py-5">
          <dashboard-tiles :items="nav" />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import nav from "@/_nav_dashboard";
import DashboardTiles from "@/components/dashboard/DashboardTiles";
import CreateNavAccessCheck from "@/components/shared/mixins/CreateNavAccessCheck";

export default {
  components: { DashboardTiles },
  name: "Dashboard",
  mixins: [CreateNavAccessCheck],
  data() {
    return {
      nav: nav.items,
    };
  },
  mounted() {
    this.setUpNavItems();
  }
};
</script>
